/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipPositionMmsiGet200ResponseShip
 */
export interface ShipPositionMmsiGet200ResponseShip {
    /**
     * 
     * @type {number}
     * @memberof ShipPositionMmsiGet200ResponseShip
     */
    mmsi?: number;
}

/**
 * Check if a given object implements the ShipPositionMmsiGet200ResponseShip interface.
 */
export function instanceOfShipPositionMmsiGet200ResponseShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionMmsiGet200ResponseShipFromJSON(json: any): ShipPositionMmsiGet200ResponseShip {
    return ShipPositionMmsiGet200ResponseShipFromJSONTyped(json, false);
}

export function ShipPositionMmsiGet200ResponseShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionMmsiGet200ResponseShip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
    };
}

export function ShipPositionMmsiGet200ResponseShipToJSON(value?: ShipPositionMmsiGet200ResponseShip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
    };
}

